"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _materialSymbols = require("@design/icons/material-symbols");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Row = _styledComponents.styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 16px 20px;\n    background: none;\n    border: none;\n    color: #374151;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n\n    &:hover {\n        color: #111827;\n    }\n"])));
function BackLinkRow(_ref) {
  var label = _ref.label,
    onClick = _ref.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Row, {
    type: "button",
    onClick: onClick,
    "data-sentry-element": "Row",
    "data-sentry-component": "BackLinkRow",
    "data-sentry-source-file": "BackLinkRow.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowBackIcon, {
      width: 16,
      height: 16,
      "data-sentry-element": "ArrowBackIcon",
      "data-sentry-source-file": "BackLinkRow.tsx"
    }), label]
  });
}
var _default = exports.default = BackLinkRow;